<template>
  <div>
    <p>
      When performing a maneuver that changes more than one orbital parameter at
      once, the optimal strategy is usually not to thrust always in the same
      direction, but rather adapt the thrusting direction according to the
      position in orbit.
    </p>
    <p>
      By choosing to simulate a hypothetical maneuver, the thrust attitude mode
      will consider the attitude that the spacecraft would have if it were to
      perform the given maneuver, adapting continuously throughout the
      simulation, with the same attitudes that the spacecraft would have if it
      were to perform the given orbital transfer.
    </p>
    <p>
      The hypothetical maneuver is an orbital transfer, defined in terms of the
      desired change in the semi-major axis (sma), inclination (inc) and
      eccentricity.
    </p>
    <br />
    <p>
      <i>Nota Bene: </i> the <i>Maneuvering Strategy Design</i> simulation will
      not simulate the maneuver itself, it will just compute the optimal
      attitude for the hypothetical maneuver at each instant throughout one
      single orbit.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipHypotheticalManeuver'
}
</script>
